import { createBrowserHistory } from "history";

const accHistory = createBrowserHistory();

export default accHistory;